export enum MutationTypes {
  LOGIN_LOADING = "LOGIN_LOADING",
  LOGIN_LOADED = "LOGIN_LOADED",
  LOGOUT_LOADING = "LOGOUT_LOADING",
  LOGOUT_LOADED = "LOGOUT_LOADED",
  REFRESH_LOGIN_LOADING = "REFRESH_LOGIN_LOADING",
  REFRESH_LOGIN_LOADED = "REFRESH_LOGIN_LOADED",
  ME_LOADING = "ME_LOADING",
  ME_LOADED = "ME_LOADED",
  SEND_PASSWORD_RESET_EMAIL_LOADING = "SEND_PASSWORD_RESET_EMAIL_LOADING",
  SEND_PASSWORD_RESET_EMAIL_LOADED = "SEND_PASSWORD_RESET_EMAIL_LOADED",
  PASSWORD_RESET_LOADING = "PASSWORD_RESET_LOADING",
  PASSWORD_RESET_LOADED = "PASSWORD_RESET_LOADED",
  VERIFY_PASSWORD_RESET_TOKEN_LOADING = "VERIFY_PASSWORD_RESET_TOKEN_LOADING",
  VERIFY_PASSWORD_RESET_TOKEN_LOADED = "VERIFY_PASSWORD_RESET_TOKEN_LOADED",
  RESET_PASSWORD_RESET_STATE = "RESET_PASSWORD_RESET_STATE",
}
